/* eslint-disable relay/unused-fields */
import { graphql } from 'react-relay/legacy';

export const multiStageCheckoutTransactionQuery = graphql`
    query multiStageCheckoutTransactionQuery(
        $input: TransactionMultiStageCheckoutInput!
        $itemId: String!
        $buyerId: String = ""
        $userIds: [String]!
        $hasUserId: Boolean!
        $hasAvailableOptions: Boolean!
        $hasSetUpCheckout: Boolean!
        $hasTradeStatus: Boolean!
        $isMobile: Boolean!
        $displayCurrency: Currency
        $userCountryCode: String = ""
    ) {
        viewer {
            ...CheckoutLayout_viewer
            ...checkoutSetUpActions_viewer
            computeTransactionMultiStageCheckout(input: $input) {
                transaction {
                    ...CheckoutLayout_transaction
                    ...checkoutSetUpActions_transaction
                    checkoutPageViewTracking(
                        hasAvailableOptions: $hasAvailableOptions
                        countryCode: $userCountryCode
                    ) @skip(if: $hasSetUpCheckout)
                    buyerInvoice {
                        invoiceItems {
                            code
                            totalAmount {
                                amount
                            }
                        }
                    }
                    summary {
                        invoiceSummary {
                            buyerCurrentInvoicePromotionTotal {
                                currency
                                amount
                            }
                        }
                    }
                    isKlarnaEligible: isPaymentMethodEligible(paymentMethod: KLARNA)
                    serviceId
                }
            }
        }
    }
`;
